// ═══════════════════════════════════════════════════════════════
// consolidationApi.js — Service API pour la consolidation mémoire (S48)
// ═══════════════════════════════════════════════════════════════

const getToken = () => localStorage.getItem('oracle_token');

const headers = () => ({
    'Authorization': `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
});

async function handle(response) {
    if (!response.ok) {
        const err = await response.json().catch(() => ({ error: `Erreur ${response.status}` }));
        const e = new Error(err.error || `Erreur ${response.status}`);
        e.code = err.code;
        e.status = response.status;
        throw e;
    }
    return response.json();
}

/**
 * Estime les coûts pour les 3 modèles avant génération.
 */
export async function estimateDistill(projectId, sessionRef) {
    const r = await fetch(`/api/projects/${projectId}/sessions/${sessionRef}/distill/estimate`, {
        headers: headers(),
    });
    return handle(r);
}

/**
 * Génère une preview de synthèse (non-destructif).
 */
export async function distillSession(projectId, sessionRef, { model = 'sonnet', includeFiles = false } = {}) {
    const r = await fetch(`/api/projects/${projectId}/sessions/${sessionRef}/distill`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ model, include_files: includeFiles }),
    });
    return handle(r);
}

/**
 * Applique atomiquement la synthèse (archive messages + crée fichier + régénère mémoire).
 */
export async function consolidateSession(projectId, sessionRef, { synthesisEdited, modelUsed, costUsd = 0 }) {
    const r = await fetch(`/api/projects/${projectId}/sessions/${sessionRef}/consolidate`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({
            synthesis_edited: synthesisEdited,
            model_used: modelUsed,
            cost_usd: costUsd,
        }),
    });
    return handle(r);
}

/**
 * Rollback d'une consolidation (dans les 90 jours).
 */
export async function rollbackConsolidation(projectId, consolidationId) {
    const r = await fetch(`/api/projects/${projectId}/consolidations/${consolidationId}/rollback`, {
        method: 'POST',
        headers: headers(),
    });
    return handle(r);
}

/**
 * Historique des consolidations du projet.
 */
export async function listConsolidations(projectId) {
    const r = await fetch(`/api/projects/${projectId}/consolidations`, {
        headers: headers(),
    });
    const data = await handle(r);
    return data.consolidations || [];
}
